import { atom } from "recoil";

export const sigmetUnreadState = atom({
  key: 'sigmetUnreadState',
  default: []
});

export const sigmetUnreadVisibleState= atom({
  key: 'sigmetUnreadVisibleState',
  default: true
});